import { render } from "./PopupWalletDeposit.vue?vue&type=template&id=3f91ef23&scoped=true"
import script from "./PopupWalletDeposit.vue?vue&type=script&lang=js"
export * from "./PopupWalletDeposit.vue?vue&type=script&lang=js"

import "./PopupWalletDeposit.vue?vue&type=style&index=0&id=3f91ef23&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f91ef23"]])

export default __exports__